import { TOKEN_SHORTCUT, TOKEN_ICONS } from 'shared/constants';

export interface TokenData {
  name: string;
  address: string;
  symbol: string;
  decimals: number;
  chainId: number;
  logoURI: string;
}

export const USDT_TOKEN: TokenData = {
  name: 'Tether USD',
  address: '0x55d398326f99059ff775485246999027b3197955',
  symbol: 'USDT',
  decimals: 18,
  chainId: 56,
  logoURI: TOKEN_ICONS.usdt,
};

export const MAIN_GAME_TOKEN: TokenData = {
  name: TOKEN_SHORTCUT,
  address: import.meta.env.REACT_APP_TOKEN_ADDRESS as string,
  symbol: TOKEN_SHORTCUT,
  decimals: 18,
  chainId: 56,
  logoURI: TOKEN_ICONS.bobeCoin,
};

export const DON_TOKEN: TokenData = {
  name: 'DON',
  address: '',
  symbol: 'DON',
  decimals: 0,
  chainId: 56,
  logoURI: TOKEN_ICONS.donCoin,
};

export const TON_TOKEN: TokenData = {
  name: 'TON',
  address: '',
  symbol: 'TON',
  decimals: 9,
  chainId: 0,
  logoURI: TOKEN_ICONS.ton,
};

export const STARS_TOKEN: TokenData = {
  name: 'Stars',
  address: '',
  symbol: 'Stars',
  decimals: 0,
  chainId: 0,
  logoURI: TOKEN_ICONS.stars,
};
